import { call, put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { IStateCustomDataDisplayState, IStateCustomElements } from '../store/nemsisCustomData.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'
import { convertToFormattedStateResults, removeUnwantedData } from '../utils/customElements.util'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'

export function* saveCustomData() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrID: string = yield select(getPcrIdSelector)
    const { stateCustomElements }: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)

    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const removeOtherData = removeUnwantedData(stateCustomElements)
      const customDataToStoreInPCR = convertToFormattedStateResults(removeOtherData as IStateCustomElements)
      const pcrDocUpdated = {
        ...pcrDoc,
        customData: customDataToStoreInPCR,
        customDisplayData: removeOtherData as IStateCustomElements,
      }
      try {
        yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      } catch (e) {
        yield put(throwPcrException(`saveCustomData() error: ${e}`))
      }
    } else {
      // todo: add to audit log
    }
  } catch (e) {
    yield put(throwPcrException(`saveCustomData() error: ${e}`))
  }
}

export function* saveCustomDataSaga() {
  yield takeLatest([StateCustomDataConstants.SET_STATE_CUSTOM_DISPLAY_DATA], performWithMutexHOG, saveCustomData)
}
